import { lazyMountAndShowFullOptions } from 'owa-options-view';

export default function showFilePickerOption() {
    lazyMountAndShowFullOptions.importAndExecute('mail', 'attachments');
}
